/* eslint-disable function-paren-newline */
import { CheckoutAction } from "../../../shared/interfaces/reducers/reducer.interface";
import * as types from "../consts";

const initState = {
  checkout: {},
  checkoutIsOk: false
};

export default function CheckoutReducer(
  state = initState,
  action: CheckoutAction) {
  switch (action.type) {
    case types.POST_CHECKOUT_REQUEST:
      return { ...state, checkoutIsOk: false };
    case types.POST_CHECKOUT_SUCCESS:
      return { ...state, checkout: action.response, checkoutIsOk: true };
    case types.POST_CHECKOUT_ERROR:
      return { ...state, checkoutIsOk: false };
    default:
      return state;
  }
}
